export const TRANSLATION_KEYS = {
  TEXTO_1: {
    key: "eventodeportivo_carruseletapas_texto_parrafo1",
    length: 11,
  },
  TEXTO_2: {
    key: "eventodeportivo_carruseletapas_texto_parrafo2",
    length: 11,
  },
  TEXTO_3: {
    key: "eventodeportivo_carruseletapas_texto_parrafo3",
    length: 11,
  },
  IN_PROGRESS: {
    key: "eventodeportivo_carruseletapas_ficha_texto_IN_PROGRESS",
  },
  COMPLETED: {
    key: "eventodeportivo_carruseletapas_ficha_texto_COMPLETED",
    length: 11,
  },
  SCHEDULED: {
    key: "eventodeportivo_carruseletapas_ficha_texto_SCHEDULED",
    length: 11,
  },
  TITLE_1_ROUND_OF_32: {
    key: "eventodeportivo_carruseletapas_texto_titulo1_ROUND_OF_32",
    length: 25,
  },
  TITLE_2_ROUND_OF_32: {
    key: "eventodeportivo_carruseletapas_texto_titulo2_ROUND_OF_32",
    length: 25,
  },
  TITLE_1_ROUND_OF_16: {
    key: "eventodeportivo_carruseletapas_texto_titulo1_ROUND_OF_16",
    length: 25,
  },
  TITLE_2_ROUND_OF_16: {
    key: "eventodeportivo_carruseletapas_texto_titulo2_ROUND_OF_16",
    length: 25,
  },
  TITLE_1_QUARTER_FINALS: {
    key: "eventodeportivo_carruseletapas_texto_titulo1_QUARTER_FINALS",
    length: 25,
  },
  TITLE_2_QUARTER_FINALS: {
    key: "eventodeportivo_carruseletapas_texto_titulo2_QUARTER_FINALS",
    length: 25,
  },
TITLE_1_SEMI_FINALS: {
    key: "eventodeportivo_carruseletapas_texto_titulo1_SEMI_FINALS",
    length: 25,
  },
  TITLE_2_SEMI_FINALS: {
    key: "eventodeportivo_carruseletapas_texto_titulo2_SEMI_FINALS",
    length: 25,
  },
  TITLE_3_SEMI_FINALS: {
    key: "eventodeportivo_carruseletapas_texto_titulo3_SEMI_FINALS",
    length: 25,
  },
  TITLE_1_FINAL: {
    key: "eventodeportivo_carruseletapas_texto_titulo1_FINAL",
    length: 25,
  },
  TITLE_2_FINAL: {
    key: "eventodeportivo_carruseletapas_texto_titulo2_FINAL",
    length: 25,
  },
  TITLE_1_THIRD_PLACE: {
    key: "eventodeportivo_carruseletapas_texto_titulo1_THIRD_PLACE"
  },
  TITLE_2_THIRD_PLACE: {
    key: "eventodeportivo_carruseletapas_texto_titulo2_THIRD_PLACE"
  },
  TITLE_3_THIRD_PLACE: {
    key: "eventodeportivo_carruseletapas_texto_titulo3_THIRD_PLACE"
  },
  FINAL_TITLE: {
    key: "eventodeportivo_carruseletapas_ficha_texto_titulo_resultados",
    length: 31,
  },
  THIRD_PLACE: {
    key: "eventodeportivo_carruseletapas_ficha_texto_3lugar",
    length: 11,
  },
  SECOND_PLACE: {
    key: "eventodeportivo_carruseletapas_ficha_texto_2lugar",
    length: 11,
  },
  FIRST_PLACE: {
    key: "eventodeportivo_carruseletapas_ficha_texto_1lugar",
    length: 11,
  }
  
};
